import {
  onlyNumbersWithoutZeroRegex,
  SOF_QUESTIONS_CONFIG,
  SOF_REGEX,
} from '../SOF.constants';
import { SOFPayload, SOFPayloadAnswer, SOFQuestion } from '../SOF.types';

export const getError = (
  questionId: SOFQuestion['id'],
  payload: SOFPayload,
) => {
  const { required } = SOF_QUESTIONS_CONFIG[questionId];
  const answers = payload[questionId];

  return {
    major: getMajorError(answers, required),
    incomeType: getSingleFieldValidationError(
      questionId,
      '1',
      'incomeType',
      answers,
    ),
    amount: getArrayValidationError(questionId, '1', 'amount', answers),
    jobTitle: getArrayValidationError(questionId, '2', 'jobTitle', answers),
    companyName: getArrayValidationError(
      questionId,
      '2',
      'companyName',
      answers,
    ),
    industry: getSingleFieldValidationError(
      questionId,
      '2',
      'industry',
      answers,
    ),
    natureOfBusiness: getSingleFieldValidationError(
      questionId,
      '2',
      'natureOfBusiness',
      answers,
    ),
  };
};

export const getSingleFieldValidationError = (
  questionId: string,
  expectedId: string,
  field: keyof SOFPayloadAnswer,
  answers: Record<string, SOFPayloadAnswer>,
) => {
  if (questionId !== expectedId) return '';

  for (const el of Object.values(answers)) {
    const value = el[field];

    if (typeof value === 'string' && el.answer !== '') {
      if (value === '') {
        return 'This field is mandatory.';
      }

      if (!SOF_REGEX.test(value)) {
        return 'The text must be between 3 and 150 characters';
      }
    }
  }

  return '';
};

export const getArrayValidationError = (
  questionId: string,
  expectedId: string,
  field: keyof SOFPayloadAnswer,
  answers: Record<string, SOFPayloadAnswer>,
) => {
  if (questionId !== expectedId) return [];

  return Object.values(answers).reduce(
    (errors, el) => {
      const rawValue = el[field];

      if (typeof rawValue !== 'string' || el.answer === '') return errors;

      const value = rawValue.trim();

      if (value === '') {
        errors.push({
          controlId: el.controlId,
          text: 'This field is mandatory.',
        });
      } else if (
        field === 'amount' &&
        !onlyNumbersWithoutZeroRegex.test(value)
      ) {
        errors.push({
          controlId: el.controlId,
          text: 'This field accepts only numbers.',
        });
      } else if (field !== 'amount' && !SOF_REGEX.test(value)) {
        errors.push({
          controlId: el.controlId,
          text: 'The text must be between 3 and 150 characters.',
        });
      }

      return errors;
    },
    [] as { controlId: string; text: string }[],
  );
};

export const isCharacterCountError = (
  answers: Record<string, SOFPayloadAnswer>,
): boolean | undefined =>
  Object.values(answers).some(
    ({ answer }) => answer !== '' && !SOF_REGEX.test(answer.trim()),
  );

const getMajorError = (
  answers: Record<string, SOFPayloadAnswer>,
  required: boolean,
): string => {
  if (isCharacterCountError(answers)) {
    return 'This field must be between 3 and 150 characters.';
  }

  if (!required) return '';

  if (isMandatoryError(answers)) {
    return 'This field is mandatory.';
  }

  return '';
};

export const isMandatoryError = (
  answers: Record<string, SOFPayloadAnswer>,
): boolean => !Object.values(answers).some(({ answer }) => answer !== '');

export const isInvalidAdditionalAnswer = (
  additionalAnswer?: string,
): boolean =>
  additionalAnswer ? !SOF_REGEX.test(additionalAnswer.trim()) : false;
